/**
 * COMPONENTE PRINCIPAL DE LA APLICACIÓN
 * 
 * Este es el punto de entrada principal que orquesta toda la aplicación.
 * Maneja la arquitectura de Context Providers y la estructura de secciones.
 * 
 * ARQUITECTURA DE PROVIDERS (ORDEN CRÍTICO):
 * 1. LanguageProvider - Sistema de internacionalización (ES/EN)
 * 2. ThemeProviderApp - Sistema de temas (claro/oscuro) 
 * 3. ChakraProvider - Biblioteca de componentes UI
 * 
 * SISTEMA DE ANIMACIONES:
 * - Cada sección está envuelta en LazySection para animaciones viewport-triggered
 * - Solo se usan animaciones seguras: fadeUp, fadeIn, scale
 * - NUNCA usar fadeLeft/fadeRight (causan scroll horizontal)
 */

import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import Header from './components/Header';
import Landing from './components/Landing';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Perfil from './components/Perfil';
import Experience from './components/Experience';
import Education from './components/Education';
import LazySection from './components/LazySection';
import ThemeProviderApp from './context/ThemeContext';
import LanguageProvider from './context/LanguageContext';
import Footer from './components/Footer';
import VirtualAssistant from './components/VirtualAssistant';

// Configuración de tema personalizada para Chakra UI
const theme = extendTheme({
  fonts: {
    body: "'Roboto', sans-serif",
    heading: "'Roboto', sans-serif",
  },
});

function App() {

  return (
    // ORDEN CRÍTICO DE PROVIDERS - NO CAMBIAR
    <LanguageProvider>
      <ThemeProviderApp>
        <ChakraProvider theme={theme}>
          <main>
            {/* Header fijo - no necesita LazySection */}
            <Header />
            
            {/* Landing - sección hero sin animación (carga inmediata) */}
            <Landing />
            
            {/* Secciones principales con animaciones viewport-triggered */}
            <LazySection animationType="fadeUp" delay={0.1}>
              <Perfil />
            </LazySection>
            
            <LazySection animationType="fadeIn" delay={0.2}>
              <Experience />
            </LazySection>
            
            <LazySection animationType="scale" delay={0.1}>
              <Projects />
            </LazySection>
            
            <LazySection animationType="fadeUp" delay={0.2}>
              <Education />
            </LazySection>
            
            <LazySection animationType="fadeIn" delay={0.2}>
              <Contact />
            </LazySection>
            
            <LazySection animationType="fadeUp" delay={0.1}>
              <Footer/>
            </LazySection>
            
            {/* Asistente Virtual - componente flotante */}
            {/* <VirtualAssistant /> */}
          </main>
        </ChakraProvider>
      </ThemeProviderApp>
    </LanguageProvider>
  );
}

export default App;
